import React from 'react';
import PropTypes from 'prop-types';

const FeatureList = ({ items = [] }) => (
  <div className="grid grid-cols-2 gap-x-6 md:gap-x-20 gap-y-6 md:gap-y-8 mt-12">
    {items.map(({ icon: Icon, title, description, disclaimer }) => (
      <div key={title} className="flex items-start gap-3 md:gap-4">
        <div>
          {/* Icon */}
          <Icon className="text-[#014B35] w-7 h-7 flex-shrink-0 mt-1 mb-2" />

          {/* Title */}
          <h3 className="text-xs md:text-base md:text-lg font-normal text-[#003424]">{title}</h3>

          {/* Description */}
          <p className="text-xs md:text-sm md:text-base font-normal text-[#6F6F6F] mt-1">{description}</p>

          {/* Optional Disclaimer */}
          {disclaimer && <p className="text-xs mt-4 font-normal text-[#6F6F6F]">{disclaimer}</p>}
        </div>
      </div>
    ))}
  </div>
);

FeatureList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.elementType.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      disclaimer: PropTypes.string,
    }),
  ),
};

export default FeatureList;
